import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconStairsSvg } from "./IconStairsSvg.mjs";
const IconStairs = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconStairsSvg, ...iconProps });
};
export {
  IconStairs
};
